// services/RatingService.js

import CONFIG from "@/config/config";

const BASE_URL = CONFIG.ENDPOINT['survey'] || "http://localhost:8300";
const DEFAULT_TIMEOUT = 10000; // 10s

class HttpError extends Error {
    constructor(message, { status, statusText, body } = {}) {
        super(message);
        this.name = "HttpError";
        this.status = status;
        this.statusText = statusText;
        this.body = body;
    }
}

const getToken = () => localStorage.getItem("token_sso") || "";

/**
 * Safe parse JSON; nếu rỗng hoặc không phải JSON hợp lệ thì trả text/null
 */
async function parseResponse(res) {
    const text = await res.text(); // đọc một lần
    if (!text) return null;
    try {
        return JSON.parse(text);
    } catch {
        return text;
    }
}

/**
 * Fetch tiện ích:
 * - method, path, data, headers
 * - timeout bằng AbortController
 * - retry cho GET (idempotent)
 */
async function jsonFetch(path, {
    method = "GET",
    data,
    headers = {},
    timeout = DEFAULT_TIMEOUT,
    retries = 0,
} = {}) {
    const url = path.startsWith("http") ? path : `${BASE_URL}${path}`;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const isJsonBody = data !== undefined && data !== null;
    const reqInit = {
        method,
        signal: controller.signal,
        headers: {
            "X-token": getToken(),
            ...headers,
        },
    };

    if (isJsonBody) {
        reqInit.headers["Content-Type"] = "application/json";
        reqInit.body = JSON.stringify(data);
    }

    try {
        const res = await fetch(url, reqInit);
        const parsed = await parseResponse(res);

        if (!res.ok) {
            throw new HttpError(`HTTP ${res.status}: ${res.statusText}`, {
                status: res.status,
                statusText: res.statusText,
                body: parsed,
            });
        }
        return parsed;
    } catch (err) {
        const canRetry =
            method === "GET" &&
            retries > 0 &&
            (err.name === "AbortError" || err instanceof TypeError); // TypeError ~ network fail
        if (canRetry) {
            return jsonFetch(path, { method, data, headers, timeout, retries: retries - 1 });
        }
        throw err;
    } finally {
        clearTimeout(id);
    }
}

/* =========================
 *   Public API functions
 * ========================= */

export async function checkSurvey() {
    return jsonFetch("/check", {
        method: "GET",
        retries: 1,
    });
}

export async function getQuestion() {
    return jsonFetch("/question", {
        method: "GET",
        retries: 1,
    });
}

export async function submitSurvey(payload) {
    return jsonFetch("/submit", {
        method: "POST",
        data: payload,
    });
}
